export default Object.freeze({
  LAYTXT1: '총 {0}개 상품 중',
  LAYTXT2: '개 상품정보 변경 완료',
  LAYTXT3: '개 상품정보 변경 불가',
  LAYTXT4: '입니다.',
  LAYTXT5: '닫기',
  LAYTXT6: '변경 완료',
  LAYTXT7: '상품번호',
  LAYTXT8: '내용',
  LAYTXT9: '상품정보가 일괄변경되었습니다.',
  LAYTXT10: '변경 불가',
  LAYTXT11: '상품번호',
  LAYTXT12: '내용'
});
